/** Stable portrait placeholders for staff (Unsplash, crop=face). */
export const STAFF_PLACEHOLDER_PHOTOS: Record<string, string> = {
  'staff-mia':
    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=256&h=256&fit=crop&crop=face',
  'staff-lina':
    'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=256&h=256&fit=crop&crop=face',
  'staff-sofia':
    'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=256&h=256&fit=crop&crop=face',
  'staff-anna':
    'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=256&h=256&fit=crop&crop=face',
};

export function getStaffPhotoUrl(staff: {
  id: string;
  displayName: string;
  photoUrl?: string | null;
}) {
  if (staff.photoUrl) {
    return staff.photoUrl;
  }

  if (STAFF_PLACEHOLDER_PHOTOS[staff.id]) {
    return STAFF_PLACEHOLDER_PHOTOS[staff.id];
  }

  return `https://api.dicebear.com/7.x/lorelei/png?seed=${encodeURIComponent(`rodeo-nails-staff-${staff.id}`)}&backgroundColor=fce7f3&size=256`;
}
